module.exports = __webpack_public_path__ + "static/media/fast_bet_second.c7bc764b.mp3";